import { createActionGroup, props } from '@ngrx/store';
import {
  GetSimilarPropertiesResponseModel,
  SimilarPropertiesParamsModel
} from '../../../shared/models/properties/properties.models';

interface SimilarPropertiesFailurePayload {
  error: unknown;
}

export const SimilarPropertiesActions = createActionGroup({
  source: 'PROPERTY',
  events: {
    'Load Similar Properties': props<SimilarPropertiesParamsModel>(),
    'Load Similar Properties Success': props<GetSimilarPropertiesResponseModel>(),
    'Load Similar Properties Failure': props<SimilarPropertiesFailurePayload>(),
  }
});